// extracted by mini-css-extract-plugin
export default {"modalTalentDetail":"style_modalTalentDetail__anYk0","videoWrapper":"style_videoWrapper__Q+2TY","contactUser":"style_contactUser__9V4sj"};